(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      // Off-canvas has no dropdowns, so hovering it must not drop the white header background
      // 오프캔버스는 드롭다운이 없으므로 호버 시 흰 헤더 배경을 내리지 않음
      if (this.querySelector('.header--off-canvas')) return;

      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Transparent off-canvas header: stick as soon as the announcement bar has scrolled away and drive the bar by scroll position (0..1 over 200px)
      // 투명 오프캔버스 헤더: 공지 바가 올라가면 바로 고정하고, 바의 변화를 스크롤 위치로 구동 (200px 동안 0..1)
      const scrollLinked = this.classList.contains('header-transparent') && this.querySelector('.header--off-canvas') !== null;
      const stickAt = scrollLinked ? this.headerBounds.top : this.headerBounds.bottom;
      if (scrollLinked) {
        const progress = Math.min(Math.max((scrollTop - this.headerBounds.top) / 200, 0), 1) || 0;
        this.header.style.setProperty('--sticky-progress', progress);
      }

      // Off-canvas keeps the floating bar in view at every width, so it skips the mobile hide-on-scroll-down branch
      // 오프캔버스는 모든 폭에서 떠 있는 바를 유지하므로 모바일의 스크롤 다운 시 숨김 분기를 건너뜀
      if ((theme.config.mqlSmall || this.scrollUpActive) && this.querySelector('.header--off-canvas') === null) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > stickAt) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            // Skip the delayed reveal if the page is back at the top by now, or the bar sticks there
            // 그 사이 맨 위로 돌아왔으면 지연된 reveal을 건너뜀. 안 그러면 맨 위에서도 sticky가 남음
            if ((window.pageYOffset || document.documentElement.scrollTop) <= stickAt) return;
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // PDP sticky add to cart: copies the main product form's price and button label, and clicking it clicks that button,
  // so variant, quantity, sold out and pre-order behaviour stay exactly the form's own
  // PDP 스티키 장바구니: 본문 상품 폼의 가격과 버튼 문구를 복사하고, 클릭하면 그 버튼을 대신 누름.
  // 옵션·수량·품절·프리오더 동작은 폼 본래 그대로 유지됨
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      // The first product form in the main content is main-product's / 본문 첫 상품 폼이 main-product의 폼
      this.source = document.querySelector('#MainContent product-form .product-form__submit');
      if (!this.source) return;
      this.price = this.source.closest('.shopify-section').querySelector('[id^="price-"]:not([id$="--alt"])');
      this.button = this.querySelector('.sticky-atc__button');
      this.button.addEventListener('click', () => this.source.click());

      this.sync = this.sync.bind(this);
      this.mutationObserver = new MutationObserver(this.sync);
      this.mutationObserver.observe(this.source, { attributes: true, childList: true, characterData: true, subtree: true });
      if (this.price) this.mutationObserver.observe(this.price, { childList: true, characterData: true, subtree: true });
      this.sync();

      // Only once the button has been scrolled fully past (above the viewport), not while it is still below
      // 버튼을 완전히 스크롤해 지나갔을 때만 (뷰포트 위쪽). 아직 아래에 있을 때는 표시 안 함
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      this.intersectionObserver.observe(this.source);
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }

    sync() {
      this.button.textContent = this.source.textContent.trim();
      this.button.disabled = this.source.disabled;
      this.button.classList.toggle('loading', this.source.classList.contains('loading'));
      const item = this.price && (this.price.querySelector('.price--on-sale .price-item--sale') || this.price.querySelector('.price-item--regular'));
      this.querySelector('.sticky-atc__price').innerHTML = item ? item.innerHTML : '';
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  } catch(e) { console.error(e); }
})();
})();
